import * as React from 'react'
import styled from '@theme/styled-components'

import { useDropzone } from 'react-dropzone'
import { FaFileCsv, FaFileUpload, FaFileMedical } from 'react-icons/fa'
import { AiOutlineFileJpg } from 'react-icons/ai'
import Swal from 'sweetalert2'
import useI18n from '@store/i18n/useI18n'

declare type FileExtension = 'text/csv'

interface Props {
  file: any
  setFile: (f: any) => void
  acceptedTypes: FileExtension[]
}

const FileDropzone = ({ file, setFile, acceptedTypes }: Props) => {
  const i18n = useI18n()

  const onDrop = React.useCallback((res: any[]) => {
    const droppedFile = res[0]
    if (acceptedTypes.indexOf(droppedFile.type) > -1) {
      setFile(droppedFile)
    } else {
      Swal.fire({
        title: i18n.t('components.filedropzone.extensionNotSupported.title'),
        text: i18n.t('components.filedropzone.extensionNotSupported.text'),
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3A8641',
        confirmButtonText: i18n.t('components.filedropzone.extensionNotSupported.confirm'),
      })
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  const FileTypeImage = ({ extension }: { extension: string }) => {
    switch (extension) {
      case 'text/csv':
        return <FaFileCsv size={100} />
      case 'image/jpeg':
        return <AiOutlineFileJpg size={100} />
      default:
        return null
    }
  }

  return (
    <MainContainer {...getRootProps()}>
      <input {...getInputProps()} />
      {file ? (
        <FileContainer>
          <FileTypeImage extension={file.type} />
          <Information>{file.name}</Information>
        </FileContainer>
      ) : isDragActive ? (
        <FileContainer>
          <FaFileMedical size={100} />
          <Information>{i18n.t('components.filedropzone.dragging')}</Information>
        </FileContainer>
      ) : (
        <FileContainer>
          <FaFileUpload size={100} />
          <Information>{i18n.t('components.filedropzone.waitingdrag')}</Information>
        </FileContainer>
      )}
    </MainContainer>
  )
}
export default FileDropzone

const MainContainer = styled('div')`
  background-color: white;
  display: flex;
  flex: 1;
  align-item: center;
  justify-content: center;
  margin: 25px;
  border-radius: 10px;
  box-shadow: inset 0px 0px 5px 1px #2224;

  cursor: pointer;
`
const FileContainer = styled('div')`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`
const Information = styled('div')`
  ${(props) => props.theme.fonts.label};
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 25px;
  display: flex;
  height: 100px;
  width: 300px;
`
